export default __webpack_public_path__ + "978b1423b53ca804bca73ac1ccbe67a5.svg";